<script>
import Alert from '../components/Alert.svelte';

  import Button from '../components/Button.svelte';

  export let titleWhite = "Monetize<br>your assets";
  export let text =
    "Curbza  is a peer-to-peer platform developer that specializes in Digital Marketplace Creation.";
  export let signUpText =
    "Join our waitlist to get updates on our products.";
  let isSubscribing = false;
  let email;
  let signUpFailed = false;
  let alertMessage = '';
  let alertType = 'error'

  const signUp = () => {
    const signUpURL = 'https://subscriptions.curbza.com/';
    const data = { email: email };

    let statusCode = 200;
    isSubscribing = true;
    signUpFailed = false;

    fetch(signUpURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    })
    .then(response => {
      statusCode = response.status;

      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    })
    .then(results => {
      const event = new CustomEvent('signupsuccess', {
        detail: results
      });
      document.dispatchEvent(event);
      email = '';
      isSubscribing = false;
    }).catch(error => {
      let msg = 'Something went wrong';
      
      if (statusCode === 401) {
        msg = 'Authorization error';
      } else if (statusCode === 409) {
        msg = 'Email already exists';
      }
      
      signUpFailed = true;
      isSubscribing = false;
      alertMessage = msg;
    });
  };
</script>

<style>
  #hero {
    height: 860px;
    position: relative;
    overflow: hidden;
  }

  #hero > img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  #hero > .container-left {
    position: absolute;
    max-width: 920px;
    max-height: 632px;
    top: 128px;
    left: 0;
    color: white;
    padding: 4vw 12vw;
  }

  #hero > .container-left .hero-title .title {
    font-size: 76px;
    font-family: 'Roboto Bold', Arial, Helvetica, sans-serif;
    line-height: 83px;
    color: white !important;
    font-size: 60px !important;
    font-weight: bold !important;
    margin-bottom: 3vw;
  }

  #hero > .container-left .hero-description {
    font-size: 32px;
    margin-top: 3vw;
    margin-bottom: 4vw;
  }

  #hero > .container-left .hero-footer .sign-up-text {
    font-size: 22px;
  }

  #hero > .container-left .hero-footer .form-control input {
    flex: 3 !important;
  }

  /* Small devices (landscape phones, 767px and up) */
  @media (max-width: 767px) {
    #hero {
      background-color: var(--primary);
      color: var(--primary-text);
      min-height: 860px;
      height: auto;
      width: 100%;
    }

    #hero > img {
      display: none;
    }

    #hero > .container-left {
      max-width: auto;
      max-height: auto;
      width: 100%;
      height: 100%;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) {

  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) {

  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    #hero > .container-left {
      width: 620px;
    }
  }

  /* Super large devices (large desktops, 1400px and up) */
  @media (min-width: 1400px) {
    #hero {
      position: relative;
      overflow: hidden;
    }

    #hero > img {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }

    #hero > .container-left {
      position: absolute;
      width: 840px;
      height: 632px;
      top: 0;
      left: 0;
    }
  }

  @media only screen and (max-width: 767px) {
    #hero > .container-left {
      top: 0;
      text-align: center;
    }
  }
</style>

<main id="hero">
  <img
    src="../assets/images/wallpapers/bg-hero-1920.jpg"
    alt="Background">
  <div class="container-left">
    <div class="hero-title">
      <h1 class="title">{@html titleWhite}</h1>
    </div>

    <div class="hero-description">{text}</div>

    <div class="hero-footer">
      <p class="sign-up-text">{signUpText}</p>
      <div class="form-control">
        <label for="email">Email Address (example@email.com)</label>
        {#if signUpFailed}
        <Alert type={alertType}>{alertMessage}</Alert>
        {/if}
        <div class="row">
          <input
            id="email"
            name="email"
            type="email"
            class="flex-3 margin-right-1vw"
            bind:value={email}
            on:keydown={(e) => { if (e.code === 'Enter') signUp() }} />
          <Button
            classNames="btn btn-accent"
            style="width: 100%; font-size: 16px; line-height: 20px"
            on:click={signUp}
            busy={isSubscribing}>Sign Up</Button>
        </div>
      </div>
    </div>
  </div>
  <div class="spacer"></div>
</main>
